var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M13.112 3.429c-7.842 0.338-13.975 7.262-13.010 15.381 0.702 5.929 5.371 10.859 11.262 11.84 3.977 0.661 7.701-0.393 10.562-2.537 0.263-0.197 0.299-0.581 0.091-0.832l-8.302-10.151v-13.115c0-0.325-0.277-0.599-0.603-0.585z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M30.844 13.097c-0.309-7.093-6.002-12.789-13.095-13.095-0.327-0.016-0.606 0.261-0.606 0.587v13.113h13.113c0.327 0 0.601-0.279 0.587-0.606z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M31.4 17.13h-13.113l8.304 10.149c0.206 0.254 0.59 0.29 0.834 0.073 2.667-2.384 4.398-5.797 4.562-9.616 0.014-0.327-0.261-0.606-0.587-0.606z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.ea244b9e5795723d17b621e5b9b382ca.svg";
export { ForwardRef as ReactComponent };